import { ConfirmationDialog } from "../../../common/ConfirmationDialog";

const ForceAssignDeviceDialog = ({
  isOpen,
  title,
  message,
  onClose,
  onForceAssignDevice,
}: {
  isOpen: boolean;
  title: string;
  message: string;
  onClose: () => void;
  onForceAssignDevice: () => void;
}) => {
  return (
    <ConfirmationDialog
      isOpen={isOpen}
      confirmationMessage={message}
      confirmationTitle={title}
      onClose={onClose}
      confirmationButtonText={"Yes"}
      shouldCloseOnConfirm={true}
      onConfirmationAction={onForceAssignDevice}
    />
  );
};

export default ForceAssignDeviceDialog;
